import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ChatRailTravelcardsRequest } from '@sabstravtech/obtservices/base';
import { RailTicketExtra } from '@sabstravtech/obtservices/angular';
import { formatCardCurrency } from '../chat-card.util';

/**
 * ENT-16311 - inline chat replacement for RailTicketsDialogComponent. Evolvi
 * attaches the London travelcard options to the journey for a single date and
 * they are mutually exclusive, so this is a radio, not a multi-select: one
 * travelcard, none, or cancel the whole add.
 *
 * The chosen extra is emitted UNCHANGED. Only identifiers.type,
 * identifiers.location and identifiers.date reach the supplier (see
 * createTicketExtrasObject in rail-enterprise-search.ts), and the supplier
 * already set that date to the date of travel, so nothing here needs to re-date
 * it the way the modal does.
 */
@Component({
  selector: 'app-chat-rail-travelcards-card',
  standalone: false,
  templateUrl: './chat-rail-travelcards-card.component.html',
  styleUrls: ['./chat-rail-travelcards-card.component.scss']
})
export class ChatRailTravelcardsCardComponent {
  @Input() request!: ChatRailTravelcardsRequest;
  /** Chosen extras, [] for "no travelcard", or false to cancel the basket-add. */
  @Output() resolve = new EventEmitter<RailTicketExtra[] | false>();

  selectedIndex: number | null = null;
  resolved = false;

  select(index: number): void {
    this.selectedIndex = this.selectedIndex === index ? null : index;
  }

  addSelected(): void {
    if (this.selectedIndex === null) {
      return;
    }
    this.settle([this.request.travelcards[this.selectedIndex]]);
  }

  addWithout(): void {
    this.settle([]);
  }

  cancel(): void {
    this.settle(false);
  }

  private settle(result: RailTicketExtra[] | false): void {
    if (this.resolved) {
      return;
    }
    this.resolved = true;
    this.resolve.emit(result);
  }

  label(extra: RailTicketExtra): string {
    return [extra?.description, extra?.location].filter(Boolean).join(' - ');
  }

  /** adultAmount carries the real price; amount is 0 on most supplier records.
   *  The modal notes the grid price is per traveller, so this card says the same. */
  price(extra: RailTicketExtra): string {
    return formatCardCurrency(extra?.adultAmount ?? extra?.amount, extra?.currency || 'GBP');
  }

  childPrice(extra: RailTicketExtra): string {
    return formatCardCurrency(extra?.childAmount, extra?.currency || 'GBP');
  }
}
